import React from 'react';
import { Card, Button, Badge } from 'react-bootstrap';

const ProductoCard = ({ producto, onEdit, onDelete }) => {
  return (
    <Card className="h-100 producto-card">
      {producto.imagen ? (
        <Card.Img
          variant="top"
          src={producto.imagen}
          alt={producto.nombre}
          style={{ height: '200px', objectFit: 'cover' }}
        />
      ) : (
        <div
          style={{
            height: '200px',
            backgroundColor: '#f8f5f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <i className="fas fa-image fa-3x" style={{ color: '#c4956a' }}></i>
        </div>
      )}

      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <Card.Title className="fw-bold mb-0" style={{ fontSize: '1.1rem' }}>
            {producto.nombre}
          </Card.Title>
          {!producto.activo && (
            <Badge bg="secondary" className="ms-2">
              Inactivo
            </Badge>
          )}
        </div>

        <Card.Text className="text-muted small flex-grow-1" style={{ minHeight: '60px' }}>
          {producto.descripcion?.length > 100
            ? `${producto.descripcion.substring(0, 100)}...`
            : producto.descripcion}
        </Card.Text>

        <div className="mb-2">
          <span className="fw-bold" style={{ color: '#c4956a', fontSize: '1.3rem' }}>
            ₡{Number(producto.precio).toLocaleString('es-CR')}
          </span>
        </div>

        <div className="d-flex gap-2 mt-auto">
          <div>
            {producto.categorias?.nomCategoria && (
              <div className="mb-3">
                <Badge bg="secondary" style={{ backgroundColor: '#2A2F35' }}>
                  {producto.categorias.nomCategoria}
                </Badge>
              </div>
            )}
          </div>
          <div>
            {producto.orden && (
              <div className="mb-3">
                <Badge bg="secondary" style={{ backgroundColor: '#2A2F35' }}>
                  {producto.orden}
                </Badge>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex gap-2 mt-auto">
          <Button
            className="btn-editar flex-grow-1"
            size="sm"
            onClick={() => onEdit(producto)}
          >
            <i className="fas fa-edit me-1"></i>
            Editar
          </Button>
          <Button
            className="btn-eliminar"
            size="sm"
            style={{ minWidth: '40px' }}
            onClick={() => onDelete(producto)}
          >
            <i className="fas fa-trash"></i>
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProductoCard;